import {
	Component,
	ElementRef,
	HostListener,
	OnDestroy,
	OnInit,
} from "@angular/core";
import { Sector } from "../models/Sector";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { Map } from "../models/Map";
import { MapV2Service } from "../mapv2.service";

@Component({
	selector: "mapv2-sectors",
	templateUrl: "./mapv2-sectors.component.html",
	styleUrls: ["./mapv2-sectors.component.scss"],
})
export class MapV2SectorsComponent implements OnInit, OnDestroy {
	public map: Map | null;
	public sectors: Sector[];
	public zoom: number;
	private canvas!: HTMLCanvasElement;
	private context!: CanvasRenderingContext2D;
	private imgElement!: HTMLImageElement;
	private unsubscribe$: Subject<any>;

	constructor(
		private elementRef: ElementRef<HTMLElement>,
		private service: MapV2Service
	) {
		this.unsubscribe$ = new Subject();
		this.zoom = 1.5;
		this.sectors = [];
		this.map = null;
	}

	public ngOnInit(): void {
		this.initializeCanvas();
		this.initializeMap();
		this.initializeSectors();
	}

	public ngOnDestroy(): void {
		this.unsubscribe$.next(null);
		this.unsubscribe$.complete();
	}

	@HostListener("window:resize")
	public onResize() {
		const parentElement = this.elementRef.nativeElement.parentElement;
		if (parentElement) {
			const parentWidth = parentElement.offsetWidth;
			if (parentWidth > 0) {
				this.zoom = parentWidth / (this.imgElement.width - 150);
			}
		}
	}

	private openPlaces(sector: Sector) {
		this.service.setSelectedSector(sector);
		if (this.service.hasPlaces(sector.id)) {
			this.service.show();
		}
	}

	private fillPolygon(element: HTMLAreaElement) {
		const coords = String(element.getAttribute("coords"))
			.split(",")
			.map((c) => Number(c));

		this.context.beginPath();
		this.context.moveTo(coords[0], coords[1]);
		for (let i = 2; i < coords.length; i += 2) {
			this.context.lineTo(coords[i], coords[i + 1]);
		}
		this.context.lineTo(coords[0], coords[1]);
		this.context.fillStyle = this.map!.color;
		this.context.globalAlpha = 0.5;
		//this.context.fill();
	}

	private drawOn() {
		const mapElement = document.querySelector("#mapv2__map") as HTMLAreaElement;
		mapElement.innerHTML = "";
		if (this.sectors != null) {
			this.sectors
				.filter((sector) => sector.mapSectors.length > 0)
				.forEach((sector) => {
					sector.mapSectors.forEach((mapSector) => {
						const area = document.createElement("area");
						area.shape = "poly";
						area.style.cursor = "pointer";
						area.coords = mapSector.coords
							.map(({ x, y }) => (x) + "," + (y))
							.join(",");
						area.onmouseover = () => {
							this.fillPolygon(area);
						};
						area.onmouseout = () => {
							this.context.clearRect(
								0,
								0,
								this.canvas.width,
								this.canvas.height
							);
						};
						area.onclick = () => {
							this.openPlaces(sector);
						};
						mapElement.appendChild(area);
					});
				});
		}
	}

	private initializeCanvas(): void {
		this.canvas = document.querySelector(
			"#mapv2__sectors__canvas"
		) as HTMLCanvasElement;
		this.imgElement = document.querySelector(
			"#mapv2__sectors__img"
		) as HTMLImageElement;
		this.context = this.canvas.getContext("2d") as CanvasRenderingContext2D;
	}

	private initializeMap(): void {
		this.service
			.getMap()
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe({
				next: (map) => {
					if (map) {
						this.map = map;
						this.imgElement.src = this.map.imageSectors;
						this.imgElement.onload = () => {
							this.onResize();
							this.canvas.width = this.imgElement.width;
							this.canvas.height = this.imgElement.height;
							this.drawOn();
						};
					}
				},
			});
	}

	private initializeSectors(): void {
		this.service
			.getMapWithSectors()
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe({
				next: (map) => {                       
                    this.sectors =  map!.sectors 
                    this.drawOn();                    
				},
			});
	}
}
